/**
 * Shared reporting-chart palette (Prompt F). Kept out of ReportChart.tsx so that
 * file only exports components (react-refresh). Colours are `rgb(var(..))` off
 * the app's semantic tokens - the gold/cream/ink palette, never recharts' blues,
 * and theme-aware.
 */
export const REPORT_COLORS = {
  gold: 'rgb(var(--accent-gold-bright))',
  goldSoft: 'rgb(var(--accent-gold))',
  goldDim: 'rgb(var(--accent-gold-dim))',
  ink: 'rgb(var(--text-strong))',
  mint: 'rgb(var(--accent-mint))',
  blood: 'rgb(var(--accent-blood))',
  azure: 'rgb(var(--accent-azure))',
} as const;

/** Default series colour cycle - distinct hues, none a recharts default. */
export const REPORT_SERIES_PALETTE: readonly string[] = [
  REPORT_COLORS.gold,
  REPORT_COLORS.azure,
  REPORT_COLORS.mint,
  REPORT_COLORS.blood,
  REPORT_COLORS.goldDim,
];
